export type ReviewSource = 'Google' | 'Facebook' | 'Message' | 'Email' | 'Other'

export type PublicReview = {
  id: string
  customerDisplayName: string
  reviewText: string
  source: ReviewSource
  rating: number | null
  reviewDate: string | null
}

const REVIEW_DATE = new Intl.DateTimeFormat('en-NZ', {
  timeZone: 'Pacific/Auckland',
  day: 'numeric',
  month: 'short',
  year: 'numeric',
})

function formatReviewDate(value: string | null) {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null
  const parsed = new Date(`${value}T12:00:00.000Z`)
  return Number.isNaN(parsed.getTime()) ? null : REVIEW_DATE.format(parsed)
}

export default function ReviewCard({ review }: { review: PublicReview }) {
  const date = formatReviewDate(review.reviewDate)
  const validRating = Number.isInteger(review.rating) && Number(review.rating) >= 1 && Number(review.rating) <= 5
    ? Number(review.rating)
    : null

  return (
    <article className="reviews-card">
      {validRating !== null ? (
        <div className="reviews-card__rating" aria-label={`${validRating} out of 5 stars`}>
          <span aria-hidden="true">{'★'.repeat(validRating)}</span>
        </div>
      ) : null}
      <blockquote className="reviews-card__quote">
        <p>{review.reviewText}</p>
      </blockquote>
      <p className="reviews-card__customer">{review.customerDisplayName}</p>
      {date ? (
        <time className="reviews-card__date" dateTime={review.reviewDate ?? undefined}>{date}</time>
      ) : null}
    </article>
  )
}
